import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const analyticsUserDetailsAction = createAsyncThunk(
    'analytics-user-details',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/analytics-user-details?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const analyticsUserDetailsSlice = createSlice({
    name: 'analytics-user-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(analyticsUserDetailsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(analyticsUserDetailsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(analyticsUserDetailsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const analyticsUserDetailsReducer = analyticsUserDetailsSlice.reducer